export default class ResourcesPage {

    perPage = 6;
    searchInput = '';

    constructor() {
        this.addEvents();
    }

    addEvents() {
        let that = this;
        let resourcesCatsItems = document.querySelectorAll('.resources__cats--item');
        let resourcesMoreBtn = document.querySelectorAll('.resources__more--btn');
        let resourcesSearchInput = document.querySelectorAll('.resources__search--input');

        resourcesCatsItems.forEach(function (item) {
            item.addEventListener('click', function (e) {
                e.preventDefault();
                if (item.classList.contains('active')) {
                    item.classList.remove('active');
                } else {
                    item.classList.add('active');
                }
                that.filter();
            });
        });

        function handleResourcesSearchInputChange() {
            that.filter();
        }


        resourcesMoreBtn.forEach(function (item) {
            item.addEventListener('click', function (e) {
                let page = parseInt(item.getAttribute('data-page')) + 1;
                that.showMoreGenerator(that.perPage * page);
                item.setAttribute('data-page', page);
            });
        });

        ['input', 'change'].forEach(function(e) {
            resourcesSearchInput.forEach(function (item) {
                item.addEventListener(e, handleResourcesSearchInputChange);
            });

        })

        $('body').on('input change', '.resources__popup--input', function(e){
            that.filter($(this).val().toLowerCase().trim());
        })


    }


    filter(search_text = false){
        let activeTabContent = document.querySelector('.elementor-tab-content.active');
        if(!activeTabContent || activeTabContent.length == 0){
            activeTabContent = document.querySelector('body');
        }
        if(activeTabContent) {
            let resourcesMoreBtn = activeTabContent.querySelector('.resources__more--btn');
            let resourcesPostsItems = activeTabContent.querySelectorAll('.resources__posts--item');
            let resourcesCatsItems = activeTabContent.querySelectorAll('.resources__cats--item.active');

            resourcesMoreBtn.setAttribute('data-page', 1);

            resourcesPostsItems.forEach(function (item) {
                item.classList.remove('no-filter');
            });

            this.search(search_text);

            resourcesPostsItems = activeTabContent.querySelectorAll('.resources__posts--item:not(.no-filter)');

            if (resourcesCatsItems.length > 0) {
                resourcesPostsItems.forEach(function (postItem) {
                    if (postItem.getAttribute('data-tag')) {
                        const attr = postItem.getAttribute('data-tag').split(',');
                        let search = false;

                        resourcesCatsItems.forEach(function (catItem) {
                            if (attr.includes(catItem.getAttribute('data-id'))) {
                                search = true;
                            }
                        });

                        if (!search) {
                            postItem.classList.add('no-filter');
                        }
                    } else {
                        postItem.classList.add('no-filter');
                    }
                });
            }

            this.showMoreGenerator(this.perPage)
        }
    }

    search(find = null){
        var searchVal = '';
        const tablength = document.querySelectorAll('.elementor-tab-content.active').length;
        var searchInput = document.querySelector('.elementor-tab-content.active .resources__search--input');
        if(tablength == 0){
            searchInput = document.querySelector('.resources__search--input');
        }
        var searchVal = find ? find : searchInput ? searchInput.value.toLowerCase().trim() : '';

        var allFilter = document.querySelector('.elementor-tab-content.active');

        if(tablength == 0){
            allFilter = document.querySelector('body');
        }

        allFilter.querySelector('.resources__no-find').classList.remove('active');

        if (searchVal) {
            let countFilter = 0;
            var items = allFilter.querySelectorAll('.resources__posts--item:not(.no-filter)');

            items.forEach(function(item) {
                const text = item.querySelector('.resources__posts--title').textContent.toLowerCase().trim();
                if (text.indexOf(searchVal) === -1) {
                    item.classList.add('no-filter');
                    countFilter++;
                } else {
                    item.classList.remove('no-filter');
                    countFilter--;
                }
            });

            if(items.length == 0 || allFilter.querySelectorAll('.resources__posts--item.no-filter').length == countFilter){
                allFilter.querySelector('.resources__no-find').classList.add('active');
            }
        }

        this.showMoreGenerator(this.perPage);
    }

    showMoreGenerator(count){
        const tablength = document.querySelectorAll('.elementor-tab-content.active').length;
        var items = document.querySelectorAll('.elementor-tab-content.active .resources__posts--item:not(.no-filter)');
        var resourcesMoreButton = document.querySelector('.elementor-tab-content.active .resources__more--btn');
        if(tablength == 0){
            items = document.querySelectorAll('.resources__posts--item:not(.no-filter)');
            resourcesMoreButton = document.querySelector('.resources__more--btn');
        }
        items.forEach((item, index) => {
            if (index + 1 <= count) {
                item.classList.remove('hidden');
            } else {
                item.classList.add('hidden');
            }
        });

        if (items.length > count) {
            resourcesMoreButton.classList.add('show');
        } else {
            resourcesMoreButton.classList.remove('show');
        }
    }


}
